import type {
	GoalSummarySegment,
	GoalSummarySegmentData,
	GoalSummarySegmentFormatOptions,
	GoalSummarySegmentKind,
} from "web_myplann/Goals/Types/GoalSummary";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const SummaryResources = Resources.Goals.Detail.Summary;

const PRICE_LABEL_KEYS: Record<
	GoalCategoryTypeEnum,
	typeof SummaryResources.PriceLabels.total
> = {
	[GoalCategoryTypeEnum.House]: SummaryResources.PriceLabels.housing,
	[GoalCategoryTypeEnum.Car]: SummaryResources.PriceLabels.car,
	[GoalCategoryTypeEnum.Basic]: SummaryResources.PriceLabels.total,
	[GoalCategoryTypeEnum.Student]: SummaryResources.PriceLabels.total,
	[GoalCategoryTypeEnum.Vacation]: SummaryResources.PriceLabels.total,
	[GoalCategoryTypeEnum.Pension]: SummaryResources.PriceLabels.rent,
	[GoalCategoryTypeEnum.Rent]: SummaryResources.PriceLabels.rent,
};

const LABEL_KEYS: Record<
	Exclude<GoalSummarySegmentKind, "price">,
	typeof SummaryResources.mustHave
> = {
	mustHave: SummaryResources.mustHave,
	mortgage: SummaryResources.thenMortgage,
	loan: SummaryResources.thenLoan,
	ownFunds: SummaryResources.setAside,
};

export const formatGoalSummarySegment = (
	segment: GoalSummarySegmentData,
	{ category, currencyCode, t, formatAmount }: GoalSummarySegmentFormatOptions,
): GoalSummarySegment => ({
	label: t(
		segment.kind === "price"
			? PRICE_LABEL_KEYS[category]
			: LABEL_KEYS[segment.kind],
	),
	value: formatAmount(segment.amount, currencyCode),
	note: segment.setAsideAmount
		? t(SummaryResources.alreadySetAside, {
				amount: formatAmount(segment.setAsideAmount, currencyCode, {
					withSymbol: false,
				}),
			})
		: undefined,
});
